import React, { useState } from "react";
import Icon from "./Icon";
import WrappedDiagram from "./Diagram";
import MessageDialog from "./Login/MessageDialog";
import { Box, Typography } from "@mui/material";
import { SampleRegistrationTypes } from "../types/samples.types";
import Button from "./MButton";

interface SampleInformationProps {
  sample: SampleRegistrationTypes;
}

const SampleInformation: React.FC<SampleInformationProps> = ({ sample }) => {
  const [dialogData, setDialogData] = useState<any>({});

  const handleComponent = () => {
    setDialogData({ active: false });
  };

  return (
    <>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          minHeight: "70vh",
          marginLeft: "2rem",
          position: "relative",
        }}
        className="sampleInformation"
      >
        <Box sx={{ position: "absolute", top: 0 }} className="info">
          <Typography sx={{ fontSize: 16, color: "black" }} className="title">
            Referencia MASL
          </Typography>
          <Typography
            sx={{
              marginTop: 1,
              marginBottom: 1,
              marginLeft: 2,
              fontSize: 14,
              color: "#8F8D8D",
            }}
          >
            {sample?.masl_reference}
          </Typography>
          {sample?.client_reference && (
            <>
              <Typography
                sx={{ fontSize: 16, color: "black" }}
                className="title"
              >
                Referencia Cliente
              </Typography>
              <Typography
                sx={{
                  marginTop: 1,
                  marginBottom: 1,
                  marginLeft: 2,
                  fontSize: 14,
                  color: "#8F8D8D",
                }}
              >
                {sample?.client_reference}
              </Typography>
            </>
          )}
          <Typography sx={{ fontSize: 16, color: "black" }} className="title">
            Instalación
          </Typography>
          <Typography
            sx={{
              marginTop: 1,
              marginBottom: 1,
              marginLeft: 2,
              fontSize: 14,
              color: "#8F8D8D",
            }}
          >
            {sample?.installation.codigo}
          </Typography>
          <Typography sx={{ fontSize: 16, color: "black" }} className="title">
            Tipo de muestra
          </Typography>
          <Typography
            sx={{
              marginTop: 1,
              marginBottom: 1,
              marginLeft: 2,
              fontSize: 14,
              color: "#8F8D8D",
            }}
          >
            {sample?.sample_type.codigo}
          </Typography>
          <Typography sx={{ fontSize: 16, color: "black" }} className="title">
            Análisis compartido
          </Typography>
          <Typography
            sx={{
              marginTop: 1,
              marginBottom: 1,
              marginLeft: 2,
              fontSize: 14,
              color: "#8F8D8D",
            }}
          >
            {sample?.shared ? "Sí" : "No"}
          </Typography>
          <Typography sx={{ fontSize: 16, color: "black" }} className="title">
            Nº de muestras
          </Typography>
          <Typography
            sx={{
              marginTop: 1,
              marginBottom: 1,
              marginLeft: 2,
              fontSize: 14,
              color: "#8F8D8D",
            }}
          >
            {sample?.sample_number}
          </Typography>
          <Typography sx={{ fontSize: 16, color: "black" }} className="title">
            Acumulado
          </Typography>
          <Typography
            sx={{
              marginTop: 1,
              marginBottom: 1,
              marginLeft: 2,
              fontSize: 14,
              color: "#8F8D8D",
            }}
          >
             {sample?.accumulation?.code ?? ""}
          </Typography>
          <Typography sx={{ fontSize: 16, color: "black" }} className="title">
            Motivo
          </Typography>
          <Typography
            sx={{
              marginTop: 1,
              marginBottom: 1,
              marginLeft: 2,
              fontSize: 14,
              color: "#8F8D8D",
            }}
          >
            {sample?.reason.codigo}
          </Typography>
          <Typography sx={{ fontSize: 16, color: "black" }} className="title">
            Punto de muestreo
          </Typography>
          <Typography
            sx={{
              marginTop: 1,
              marginBottom: 1,
              marginLeft: 2,
              fontSize: 14,
              color: "#8F8D8D",
            }}
          >
            {sample?.sampling_points?.codigo ?? ""}
          </Typography>
        </Box>
        <Box
          sx={{
            position: "absolute",
            bottom: 0,
            width: "100%",
            display: "flex",
            justifyContent: "center",
            cursor: "pointer",
          }}
          onClick={() =>
            setDialogData({ component: "diagram", active: true, size: "2xl" })
          }
        >
          <Icon name="list-tree" width="70px" />
        </Box>
      </Box>
      <MessageDialog data={dialogData} handleClose={handleComponent}>
        <WrappedDiagram data={sample} />
        <Box sx={{ display: "flex", justifyContent: "center", marginTop: 2 }}>
          <Button onClick={handleComponent} text="Cerrar" />
        </Box>
      </MessageDialog>
    </>
  );
};

export default SampleInformation;
